import { render, staticRenderFns } from "./Video_Data.vue?vue&type=template&id=68b9f91e&"
import script from "./Video_Data.vue?vue&type=script&lang=js&"
export * from "./Video_Data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports